import { render, staticRenderFns } from "./UserMetaDetails.vue?vue&type=template&id=02301802"
import script from "./UserMetaDetails.vue?vue&type=script&lang=js"
export * from "./UserMetaDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports